import { cloneElement, FC } from "react";

import { Theme, SxProps } from "@mui/material";
import classNames from "classnames";

import { RippleFormButton, RippleFormButtonProps } from "@/forms-design-system/FormButton";
import { mergeSx } from "@/helpers/mergeSx";
import { IconElement } from "@/icons/types";

export type BaseFormCounterButtonProps = Omit<
  RippleFormButtonProps,
  "size" | "startIcon" | "endIcon" | "iconButton"
> & {
  icon: IconElement;
};

export const BaseFormCounterButton: FC<BaseFormCounterButtonProps> = ({ icon, children, sx, ...rest }) => {
  const styles: SxProps<Theme> = mergeSx(
    {
      "& .form-counter-button-rotate-icon": {
        position: "relative",
        transition: "transform 300ms ease-in-out",
        zIndex: 10,
      },
      "&:hover .form-counter-button-blowup-icon": {
        width: 0,
        opacity: 0.5,
      },
    },
    sx
  );

  const rotateIcon = cloneElement(icon, {
    className: classNames(icon.props.className, "form-counter-button-rotate-icon"),
  });

  if (children) {
    return (
      <RippleFormButton size="medium" endIcon={rotateIcon} sx={styles} {...rest}>
        {children}
      </RippleFormButton>
    );
  }

  return <RippleFormButton size="medium" iconButton startIcon={rotateIcon} sx={styles} {...rest} />;
};
